import api from "../api/api";

export const getCategories = async () => {
  try {
    const response = await api.get("web/categories");
    return response.data.data; // Extract `data` array
  } catch (error) {
    console.error("Failed to fetch categories:", error);
    throw error;
  }
};
